import React from 'react';
import { CheckIcon, SelectLogoEmptyStateIcon } from '@rsos/assets/icons';
import { Box } from '@rsos/components/capstone/base';
import {
  Container,
  Selector,
  DescriptionContainer,
  DescriptionWrapper,
  Description,
  Name,
  NameContainer,
  EmptyContainer,
  IconWrapper,
} from './DataSources.styles';

const DataSourcesSelect = ({
  datas,
  partner,
  setPartner,
  hoveredPartner,
  setHoveredPartner,
}) => {
  return (
    <Container>
      <Selector>
        {datas.map(data => (
          <NameContainer
            key={data.name}
            selected={partner && partner.name === data.name}
            onClick={() => setPartner(data)}
            onMouseEnter={() => setHoveredPartner(data)}
            onMouseLeave={() => setHoveredPartner(null)}
          >
            <IconWrapper
              color={'panePrimaryText'}
              pl={3}
              pr={2}
              selected={partner && partner.name === data.name}
            >
              <CheckIcon width={20} height={20} />
            </IconWrapper>
            <Name ellipsis>{data.name}</Name>
          </NameContainer>
        ))}
      </Selector>
      <DescriptionContainer>
        {partner || hoveredPartner ? (
          <DescriptionWrapper visible={partner || hoveredPartner}>
            <Box inline horizontal pb="6px">
              <Description inline>
                <Description inline color="primaryText">
                  {(hoveredPartner && hoveredPartner.name) || partner.name}
                  &nbsp;
                </Description>
                {(hoveredPartner && hoveredPartner.description.title) ||
                  partner.description.title}
              </Description>
            </Box>
            <Description size="small">
              {(hoveredPartner && hoveredPartner.description.content) ||
                partner.description.content}
            </Description>
          </DescriptionWrapper>
        ) : (
          <EmptyContainer color={'lightLineDivider'}>
            <SelectLogoEmptyStateIcon width={85} height={85} />
          </EmptyContainer>
        )}
      </DescriptionContainer>
    </Container>
  );
};

export default DataSourcesSelect;
